<template>
  <a-table
    id="tableDataTabs"
    :columns="columns"
    :dataSource="tableData"
    :pagination="false"
    bordered> </a-table>
</template>
<script>
import { getAssetDetail } from '@/api/assetLedger'
export default {
  props: {
    model: Object
  },
  watch: {
    model: {
      handler (model) {
        console.log('接口', model)
        this.initDetail(model)
      },
      immediate: true
    }
  },
  data () {
    return {
      columns: [
        {
          title: '序号',
          customRender: (text, record, index) => {
            return index + 1
          },
          width: 50
        },
        {
          title: '源资产卡片号',
          dataIndex: 'assetNumber',
          align: 'center'
        },
        {
          title: '源资产描述',
          dataIndex: 'txt50',
          align: 'center'
        }
      ],
      tableData: []
    }
  },
  methods: {
    // 获取表格数据
    initDetail () {
      function isZero (value) {
        return value === '0'
      }
      const { model } = this
      if (model.aibn1 && model.aibn2) {
        const params = {
          anln1: model.aibn1.slice(2),
          bukrs: model.bukrs
        }
        const anln2 = model.aibn2.split('')
        if (anln2.every(isZero)) {
          params.anln2 = '0'
        } else {
          params.anln2 = model.aibn2.replace(/\b(0+)/gi, '')
        }
        getAssetDetail(params).then(res => {
          if (res.status === 0) {
            this.tableData = [res.data]
          }
        })
      } else {
        this.tableData = []
      }
    }
  }
}
</script>

<style lang="less" scoped>
.table /deep/ .ant-table-thead > tr > th {
  background: #E7F4FF !important;
  padding: 10px !important;
}
.table /deep/ .ant-table-tbody > tr > td {
  padding: 10px;
}
/deep/.ant-table-placeholder {
  position: relative !important;
}
#tableDataTabs  {
  /deep/.ant-spin-nested-loading {
    >.ant-spin-container {
      .ant-table-bordered {
        .ant-table-header > table{
          border-top: 1px solid #e8e8e8;
          border-left: 1px solid #e8e8e8;
        }
        .ant-table-thead > tr > th{
          border-right: 1px solid #e8e8e8;
        }
        .ant-table-body > table{
          border-top: 1px solid #e8e8e8;
          border-left: 1px solid #e8e8e8;
        }
        .ant-table-tbody > tr > td{
          border-right: 1px solid #e8e8e8;
          border-bottom: 1px solid #e8e8e8;
        }
        .ant-table-tbody > tr.ant-table-row-selected td{
          background-color: rgba(225, 225, 225, 0);
        }
        .ant-table-footer{
          border: none !important;
        }
      }
    }
  }
}
</style>
